import React, { useContext } from 'react';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { CourseContext } from '@/modules/RegisterLayout/contexts/CoursesContextProvider';
import { RegistrationStatus } from '@/modules/common/enums';
import { Typography } from '@pw-tech/omni-ui';
import Waiting from './Waiting/Waiting';
import SkipCeePIWaiting from './Waiting/SkipCeePIWaiting';
import Pass from './Pass';
import Fail from './Fail';
import Scheduled from './Scheduled/Scheduled';
const Interview = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const {
    selectedCourseData
  } = useContext(CourseContext);
  const skipCee = selectedCourseData?.skipCeeExam;
  const renderInterviewScreenBasedOnStatus = (status: string) => {
    switch (status) {
      case RegistrationStatus.pi_waiting:
        return skipCee ? <SkipCeePIWaiting /> : <Waiting />;
      case RegistrationStatus.pi_scheduled:
        return <Scheduled />;
      case RegistrationStatus.pi_cleared:
        return <Pass />;
      case RegistrationStatus.pi_not_cleared:
        return <Fail />;
      default:
        // For MBA courses, default to MBA Waiting screen
        return <Typography variant="heading3">Invalid PI Status</Typography>;
    }
  };
  return <>{renderInterviewScreenBasedOnStatus(registrationDetails?.pi_status ?? '')}</>;
};
export default Interview;